module.exports = __webpack_public_path__ + "img/airplane-search.92f40409.svg";